import React, { useEffect, useRef, useState } from 'react';
import './FeatureSection.css';

import {
  Lightbulb,
  Users,
  UserCheck,
  TrendingUp,
  ShieldCheck,
  Award
} from 'lucide-react';

const FeatureSection = () => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const currentSection = sectionRef.current;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);

          // Animation once 
          observer.unobserve(entry.target);
        }
      },
      {
        threshold: 0.15
      }
    );

    if (currentSection) {
      observer.observe(currentSection);
    }

    return () => {
      if (currentSection) {
        observer.unobserve(currentSection);
      }
    };
  }, []);

  const whyChooseUsData = [
    {
      icon: <Lightbulb className="icon" />,
      title: 'Innovative Solutions',
      desc: 'We use the latest technologies to build future-ready solutions.'
    },
    {
      icon: <Users className="icon" />,
      title: 'Expert Team',
      desc: 'Skilled professionals with deep domain expertise.'
    },
    {
      icon: <UserCheck className="icon" />,
      title: 'Client-Focused Approach',
      desc: 'We prioritize your goals and deliver personalized solutions.'
    },
    {
      icon: <TrendingUp className="icon" />,
      title: 'Scalable Technology',
      desc: 'Solutions that grow with your business.'
    },
    {
      icon: <ShieldCheck className="icon" />,
      title: 'Reliable Support',
      desc: '24/7 support to ensure your business runs smoothly.'
    },
    {
      icon: <Award className="icon" />,
      title: 'Quality Delivery',
      desc: 'We deliver excellence, on time and every time.'
    }
  ];

  const processSteps = [
    {
      step: '01',
      title: 'Discover',
      desc: 'Understanding your business needs'
    },
    {
      step: '02',
      title: 'Strategy',
      desc: 'Planning the right solution'
    },
    {
      step: '03',
      title: 'Design',
      desc: 'Creating user-centric designs'
    },
    {
      step: '04',
      title: 'Develop',
      desc: 'Building scalable, secure solutions'
    },
    {
      step: '05',
      title: 'Launch',
      desc: 'Deploying with precision'
    },
    {
      step: '06',
      title: 'Support',
      desc: 'Providing ongoing support'
    }
  ];

  return (
    <section
      ref={sectionRef}
      className={`feature-section ${
        isVisible ? 'feature-visible' : ''
      }`}
    >
      <div className="feature-container">

        {/* ================================
            WHY CHOOSE MINDSTREAMX
        ================================= */}

        <div className="feature-col">

          <span className="sub-heading why-sub-heading">
            WHY CHOOSE MINDSTREAMX?
          </span>

          <div className="why-choose-list">

            {whyChooseUsData.map((item, index) => (

              <div
                key={index}
                className="why-item"
              >
                <div className="icon-box">
                  {item.icon}
                </div>

                <div className="why-text">
                  <h4>{item.title}</h4>

                  <p>{item.desc}</p>
                </div>
              </div>

            ))}

          </div>
        </div>


        {/* ================================
            OUR PROCESS
        ================================= */}

        <div className="feature-col border-left">

          <span className="sub-heading process-sub-heading">
            OUR PROCESS
          </span>

          <h2 className="main-heading">
            How We Work
          </h2>

          <div className="process-timeline">

            {processSteps.map((item, index) => (

              <div
                key={index}
                className="process-item"
              >
                <div className="step-badge">
                  {item.step}
                </div>

                <div className="process-text">
                  <h4>{item.title}</h4>

                  <p>{item.desc}</p>
                </div>
              </div>

            ))}

          </div>
        </div>

      </div>
    </section>
  );
};

export default FeatureSection;